import axios from 'axios';

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': "application/json" },
});

export class YappyFetchAPI {
    //Function to create a new yappy qr transaction
    static async newYappyQr(data, token) {
        const res = await server(`/yappy`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }
    //Function to get yappy qr transaction details
    static async getYappyTransaction(yappy_transaction_id, token) {
        const res = await server(`/yappy?yappy_transaction_id=${yappy_transaction_id}`, {
            method: "get",
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Function to make a reverse of yappy qr transaction
    static async reverseYappyTransaction(data, token) {
        const res = await server(`/yappy`, {
            method: "delete",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Function to create a new yappy btn transaction 
    static async newYappyBtnOrder(data, token) {
        const res = await server(`/btn/yappy`, {
            method: "post",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }

    //Function to make a reverse of yappy btn transaction
    static async reverseYappyBtnTransaction(data, token) {
        const res = await server(`/btn/yappy`, {
            method: "delete",
            data: data,
            headers: { 'x-access-token': token },
        });
        return res
    }


}